<div ngbDropdown #dropdown='ngbDropdown'>
  <button ngbDropdownToggle
    class="dropdown-button"
    data-cy="dropdown-toggle-button">
    <div class="dropdown-button-text">
      <span data-cy="dropdown-toggle-button-placeholder">{{dropdownDefaultButtonText}}</span>
    </div>

        <span [ngClass]="{
                'iwp-icon-gen_arrow_down': !dropdown.isOpen(),
                'iwp-icon-gen_arrow_up open': dropdown.isOpen()
            }"
      class="dropdown-toggle-button-arrow"
    data-cy="dropdown-toggle-button-arrow"></span>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-wrapper">
    @for (option of dropdownData; track option) {
      <button ngbDropdownItem
        (click)="selectedOption.emit(option)"
        class="dropdown-item"
        [attr.data-cy]="dropdownItemDataCy(option.name, true)">
        <span class="dropdown-item-text"
        [attr.data-cy]="dropdownItemDataCy(option.name)">{{ option.name }}</span>
      </button>
    }
  </div>
</div>
